import { render, staticRenderFns } from "./MeterPriceItemForm.vue?vue&type=template&id=7b20a25b"
import script from "./MeterPriceItemForm.vue?vue&type=script&lang=js"
export * from "./MeterPriceItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports